var _rect, _path, _path2, _path3, _g, _path4, _path5, _path6, _g2, _path7, _path8, _path9, _ellipse, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTsn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 400,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M317.988 149.153C310.249 146.703 307.269 147.696 300.648 158.951C295.335 167.981 292.251 172.419 290.221 170.319",
    stroke: "#1BC6EC",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3393 232.528C70.3393 232.528 64.3404 270.682 107.78 270.682C151.219 270.682 175.846 200.948 194.132 163.773C212.444 126.567 244.464 100 275.09 100C305.716 100 327.817 125.099 334.289 138.948C340.762 152.797 339.736 170.437 336.078 181.688C332.421 192.938 319.134 211.587 314.609 206.328C310.083 201.07 320.292 193.977 320.292 169.031C320.292 144.084 310.399 146.316 306.084 150.26C299.77 157.016 294.349 174.656 289.719 171.232C285.483 168.083 299.77 136.441 276.458 137.022C254.752 137.573 227.204 206.176 234.335 214.43C241.465 222.715 258.54 196.545 264.092 202.996C269.644 209.447 232.466 262.026 196.921 282.417C161.375 302.808 134.275 298.314 116.488 296.052C98.7024 293.79 69.3132 284.439 62.7355 260.165C56.1578 235.891 70.3393 232.528 70.3393 232.528Z",
    fill: "url(#paint0_linear_216_15968)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_216_15968",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 35,
    y: 219,
    width: 70,
    height: 58
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3955 222.43C72.3141 213.084 53.9957 228.037 52.9182 224.299C52.3796 224.299 37.0792 234.953 35.1396 240.187C33.2001 245.42 60.1918 264.486 63.4242 271.028L104.639 276.635C104.909 275.078 103.67 271.215 96.558 268.224C87.6684 264.486 88.4769 231.776 80.3955 222.43Z",
    fill: "url(#paint1_linear_216_15968)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_216_15968)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M70.3388 232.528C70.3388 232.528 64.34 270.682 107.779 270.682C151.218 270.682 175.845 200.948 194.131 163.772C212.443 126.567 244.464 99.9999 275.09 99.9999C305.715 99.9999 327.816 125.099 334.289 138.948C340.761 152.797 339.735 170.437 336.078 181.687C332.421 192.938 319.134 211.587 314.608 206.328C310.083 201.07 320.291 193.977 320.291 169.031C320.291 144.084 310.399 146.316 306.084 150.26C299.769 157.016 294.349 174.656 289.718 171.232C285.482 168.083 299.769 136.441 276.458 137.022C254.751 137.573 227.204 206.175 234.334 214.43C241.464 222.715 258.54 196.545 264.092 202.996C269.643 209.447 232.466 262.026 196.92 282.417C161.374 302.808 134.274 298.314 116.488 296.052C98.7019 293.79 69.3127 284.439 62.735 260.165C56.1573 235.891 70.3388 232.528 70.3388 232.528Z",
    fill: "url(#paint2_linear_216_15968)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_216_15968",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 209,
    y: 90,
    width: 129,
    height: 140
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M259.932 154.206C279.612 132.412 315.583 124.409 337.364 118.177L259.932 90.8397L209.907 125.636L224.314 229.921C234.575 209.412 250.663 164.47 259.932 154.206Z",
    fill: "url(#paint3_linear_216_15968)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_216_15968)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "darken"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3388 232.528C70.3388 232.528 64.34 270.682 107.779 270.682C151.218 270.682 175.845 200.948 194.131 163.773C212.443 126.567 244.464 100 275.09 100C305.715 100 327.816 125.099 334.289 138.948C340.761 152.797 339.735 170.437 336.078 181.688C332.421 192.938 319.134 211.587 314.608 206.328C310.083 201.07 320.291 193.977 320.291 169.031C320.291 144.084 310.399 146.316 306.084 150.26C299.769 157.016 294.349 174.656 289.718 171.232C285.482 168.083 299.769 136.441 276.458 137.022C254.751 137.573 227.204 206.176 234.334 214.43C241.464 222.715 258.54 196.545 264.092 202.996C269.643 209.447 232.466 262.026 196.92 282.417C161.374 302.808 134.274 298.314 116.488 296.052C98.7019 293.79 69.3127 284.439 62.735 260.165C56.1573 235.891 70.3388 232.528 70.3388 232.528Z",
    fill: "url(#paint4_radial_216_15968)"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_216_15968",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 60,
    y: 100,
    width: 279,
    height: 199
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3383 232.528C70.3383 232.528 64.3395 270.682 107.779 270.682C151.218 270.682 175.845 200.948 194.131 163.773C212.443 126.567 244.463 100 275.089 100C305.715 100 327.816 125.099 334.288 138.948C340.761 152.797 339.735 170.437 336.077 181.688C332.42 192.938 319.133 211.587 314.608 206.328C310.082 201.07 320.291 193.977 320.291 169.031C320.291 144.084 310.398 146.316 306.083 150.26C299.769 157.016 294.348 174.656 289.718 171.232C285.482 168.083 299.769 136.441 276.457 137.022C254.751 137.573 227.203 206.176 234.334 214.43C241.464 222.715 258.54 196.545 264.091 202.996C269.643 209.447 232.465 262.026 196.92 282.417C161.374 302.808 134.274 298.314 116.487 296.052C98.7014 293.79 69.3122 284.439 62.7345 260.165C56.1568 235.891 70.3383 232.528 70.3383 232.528Z",
    fill: "#65E3FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_216_15968)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M329.787 125.333C312.564 109.101 270.52 108.633 248.006 150.013C225.493 191.393 226.914 205.503 234.36 214.43",
    stroke: "#1BC6EC",
    strokeWidth: 2
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M244.365 155.972C236.419 173.517 229.135 199.007 234.764 216.552",
    stroke: "#1BC6EC",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M107.806 270.682C151.271 270.682 175.872 200.948 194.158 163.773C212.444 126.567 244.464 100 275.09 100C305.716 100 320.608 120.361 320.608 120.361C320.608 120.361 299.042 105.016 268.512 125.405C237.983 145.794 226.915 205.503 234.361 214.43C241.359 222.837 258.567 196.545 264.118 202.996C269.67 209.447 241.228 255.488 199.972 282.482C169.291 302.558 137.212 303.774 116.762 300.847C96.311 297.921 69.194 285.021 62.6163 260.748C61.1519 255.344 61.0513 250.474 61.0513 250.474C61.0513 250.474 64.3401 270.682 107.806 270.682Z",
    fill: "url(#paint5_linear_216_15968)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.7
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M107.806 270.682C151.271 270.682 175.872 200.948 194.158 163.773C212.444 126.567 244.464 100 275.09 100C305.716 100 320.608 120.361 320.608 120.361C320.608 120.361 299.042 105.016 268.512 125.405C237.983 145.794 226.915 205.503 234.361 214.43C241.359 222.837 258.567 196.545 264.118 202.996C269.67 209.447 241.228 255.488 199.972 282.482C169.291 302.558 137.212 303.774 116.762 300.847C96.311 297.921 69.194 285.021 62.6163 260.748C61.1519 255.344 61.0513 250.474 61.0513 250.474C61.0513 250.474 64.3401 270.682 107.806 270.682Z",
    fill: "url(#paint6_linear_216_15968)"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 304.949,
    cy: 216.5,
    rx: 4.19799,
    ry: 4.5,
    fill: "#23A7ED"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_216_15968",
    x1: 164.442,
    y1: 81.3084,
    x2: 226.247,
    y2: 313.775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0677083,
    stopColor: "#384BD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.567708,
    stopColor: "#23A6ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_216_15968",
    x1: 67.4647,
    y1: 332.71,
    x2: 197.247,
    y2: 180.519,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.154564,
    stopColor: "#2C3A9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45081,
    stopColor: "#24AAF2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_216_15968",
    x1: 25.7253,
    y1: 293.116,
    x2: 371.88,
    y2: 203.819,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00432355,
    stopColor: "#2C3A9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.322587,
    stopColor: "#24AAF2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_216_15968",
    x1: 251.404,
    y1: 79.9142,
    x2: 329.057,
    y2: 209.023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.114583,
    stopColor: "#2C3A9E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4375,
    stopColor: "#24AAF2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_216_15968",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(257 78.5) rotate(75.0364) scale(219.474 196.455)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.221489,
    stopColor: "#29379E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_216_15968",
    x1: 82.5305,
    y1: 141.538,
    x2: 231.689,
    y2: 339.278,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20D6B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.590323,
    stopColor: "#24AAF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#384BD9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_216_15968",
    x1: 291.889,
    y1: 63.5,
    x2: 12.8687,
    y2: 208.208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.208333,
    stopColor: "#FDFDFD",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.988715,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTsn);
export default __webpack_public_path__ + "static/media/TSN.9ab2a38890084f861ae8b271b0f261a9.svg";
export { ForwardRef as ReactComponent };